// tslint:disable jsx-no-lambda
import * as classNames from "classnames";
import * as React from "react";
import { alertsClasses as myClasses } from "src/controllers/alerts";

import { HTMLDivProps, Text } from "@blueprintjs/core";
import { GeoMap } from "src/controllers/alerts/components";
import { Classes } from "src/mpd-library";

import { DuoButtons, ToolBar } from 'src/components';

import "./styles.css";

export interface IGeoFenceProps extends HTMLDivProps {
  geoFence: any;
  onCancelClick?(event: any): void;
  onSaveClick?(event: any): void;
  onShapeComplete(event: any, shape: any): void;
  onSaveLayerClick(event: any, listItem: any): void;
}

interface IGeoFenceState {
  listActive?: boolean;
  searchValue?: string;
}

export class GeoFence extends React.Component<IGeoFenceProps, IGeoFenceState> {
  constructor(props: IGeoFenceProps) {
    super(props);
    this.onToggleList = this.onToggleList.bind(this);
    this.onSearchChange = this.onSearchChange.bind(this);
    this.state = {
      listActive: false
    };
  }

  public render() {
    const {
      className,
      geoFence,
      onCancelClick,
      onSaveClick,
      onShapeComplete,
      onSaveLayerClick
    } = this.props;
    const { listActive, searchValue } = this.state;

    const classes = classNames("geo-fence-container", className);

    const leftElement = <Text> Set Geo-Fence </Text>;

    const rightElement = (
      <React.Fragment>
        <DuoButtons
          firstButtonText="cancel"
          secondButtonText="save"
          firstButtonClick={onCancelClick}
          dataId={"geo-fence"}
          secondButtonClick={onSaveClick}
        />
      </React.Fragment>
    );

    return (
      <div className={classes}>
        <ToolBar
          className={myClasses.ALERTS_CONTENT_COMPOSE_CHOOSE_AUDIENCE_HEADER}
          leftElement={leftElement}
          rightElement={rightElement}
        />
        <div
          className={classNames(
            "map-container",
            listActive && "list-" + Classes.ACTIVE
          )}
        >
          <GeoMap
            style={{
              height: `100%`
            }}
            onToggleList={this.onToggleList}
            onSearchChange={this.onSearchChange}
            list={geoFence.list}
            boxClass="shape-map-info-box"
            center={geoFence.center}
            searchValue={searchValue}
            currentShape={geoFence.currentShape}
            onShapeComplete={onShapeComplete}
            onSaveLayerClick={onSaveLayerClick}
          />
        </div>
      </div>
    );
  }

  private onSearchChange(event: any){
    const searchValue = event.currentTarget.value;
    this.setState({ searchValue });
  }

  private onToggleList(event: any, listActive: boolean) {
    this.setState({ listActive });
  }
}



// WEBPACK FOOTER //
// ./src/controllers/alerts/compose/choose-audience/geo-fence.tsx